import { KeyRound, Lock, Pencil, Plus } from 'lucide-react';
import type { PropertyGroupResponse } from '@/shared/api';
import { cn } from '@/shared/lib/cn';
import { CardEditButton, AreaCard } from './AreaCard';

/**
 * Haustürcode des Objekts — ob einer hinterlegt ist, nie der Wert selbst: er ist ein
 * Zugangsgeheimnis, liegt verschlüsselt, und die Objekt-Antwort trägt nur das Ob — dieselbe
 * Hygiene wie beim WLAN-Passwort.
 */
export function ObjectAccessCodeSection({
  group,
  canEdit,
  onEdit,
}: {
  group: PropertyGroupResponse;
  canEdit: boolean;
  onEdit: () => void;
}) {
  const hasCode = group.hasBuildingAccessCode;
  const action = !canEdit ? null : hasCode ? (
    <CardEditButton label="Haustürcode bearbeiten" icon={<Pencil size={14} />} onClick={onEdit} />
  ) : (
    <CardEditButton outline icon={<Plus size={14} />} onClick={onEdit}>
      Code hinterlegen
    </CardEditButton>
  );

  return (
    <AreaCard
      title="Haustürcode"
      aside={action}
      footer={
        <p className="flex items-start gap-2">
          <Lock size={14} className="mt-0.5 shrink-0" aria-hidden />
          Gäste sehen den Code wie den Türcode erst 12 Stunden vor Anreise. Der Wert selbst wird
          hier nie angezeigt.
        </p>
      }
    >
      <div className="flex items-center gap-3">
        <span
          aria-hidden
          className={cn(
            'grid size-11 shrink-0 place-items-center rounded-xl',
            hasCode ? 'bg-sage/15 text-sage' : 'bg-card-alt text-ink-soft',
          )}
        >
          <KeyRound size={20} />
        </span>
        <div className="min-w-0">
          <p className="text-ink text-sm font-semibold">
            {hasCode ? 'Code hinterlegt' : 'Kein Code hinterlegt'}
          </p>
          <p className="text-ink-soft mt-0.5 text-sm">
            {hasCode
              ? 'Gilt für alle Apartments dieses Objekts.'
              : 'Nur nötig, wenn der Hauseingang ein Codeschloss hat.'}
          </p>
        </div>
      </div>
    </AreaCard>
  );
}
